import { gql } from "urql";
export const jobFields = gql`
  fragment JobFields on JobOpening {
    title
    slug
    skills
    responsibilities
    order
    location
    timing
    description
    seo {
      metaTitle
      metaDescription
    }
    image {
      data {
        attributes {
          url
          alternativeText
          name
        }
      }
    }
  }
`;
export const QUERY_JOBS = gql`
  ${jobFields}
  query jobOpenings(
    $limit: Int!
    $start: Int!
    $sortBy: [String]
    $filter: JobOpeningFiltersInput
  ) {
    jobOpenings(
      pagination: { start: $start, limit: $limit }
      filters: $filter
      sort: $sortBy
    ) {
      data {
        id
        attributes {
          ...JobFields
        }
      }
    }
  }
`;
export const QUERY_JOB_BY_SLUG = gql`
  ${jobFields}
  query jobOpening($slug: String!) {
    jobOpening(slug: $slug) {
      data {
        id
        attributes {
          ...JobFields
        }
      }
    }
  }
`;
